module.exports = __webpack_public_path__ + "static/img/clothing_13.ee797b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/clothing/thumbnail/clothing_13.png
// module id = GEcT
// module chunks = 0